<template>
    <div class="row align-items-center">

        <div class="col-md-2">
            <div class="image-display">
                <span v-if="(isBase64 && path_image) || (isFilePath && path_image)" class="delete-img"
                    @click="deleteImage">
                    X
                </span>
                <img v-if="isBase64 && path_image" :src="path_image" alt="Uploaded Image" />
                <img v-else-if="isFilePath && path_image" :src="getImageUrl(path_image)" alt="Uploaded Image" />
                <img v-else :src="getDefaultImage()" alt="Uploaded Image" />
            </div>
        </div>

        <div class="col-md-10">
            <div class="phone-number-input ">
                <input type="file" accept="image/*" @change="handleFileInputChange" :placeholder="placeholder"
                    :disabled="disabled" :readonly="readonly" class="form-control" ref="fileInputRef" />
                <span class="text-danger mt-3" v-for="error in v?.$errors" :key="error.$uid">
                    - {{ error.$message }} <br>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, computed, toRefs, toRef, ref, watch } from 'vue';

const props = defineProps({
    pathImage: {
        type: String,
        default: '',
    },
    modelValue: {
        type: String,
        default: '',
    },
    label: String,
    placeholder: {
        type: String,
        default: 'Enter phone number',
    },
    disabled: Boolean,
    readonly: Boolean,
    v: {
        type: Object,
    },
});
const emits = defineEmits(['update:modelValue']);

const isBase64 = computed(() => {
    // Check if modelValue is a base64 string
    return /^data:image\/[a-zA-Z]*;base64,/.test(props.modelValue);
});

const isFilePath = computed(() => {
    // Check if modelValue is a file path (assuming it's not a base64 string)
    return !isBase64.value && props.modelValue !== '';
});

const getImageUrl = (path: string) => {
    // Assuming the path is relative or absolute on the server
    return process.env.VUE_APP_URL + path; // Adjust as per your server setup
};
const getDefaultImage = () => {
    return process.env.VUE_APP_DEFAULT_IMAGE
};

// Use ref to make path_image reactive
let path_image = ref<string | null>(null);
let { pathImage } = toRefs(props);

watch(
    () => pathImage.value,
    (newValue) => {
        // Update the reactive path_image with the new value or null
        path_image.value = newValue ?? null;
    }
);

//let path_image = ref<string | null>(null);
let fileInputRef = ref<HTMLInputElement | null>(null);

const handleFileInputChange = (event: Event) => {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const base64String = e.target?.result as string;
            // Emit the base64 string to parent component
            emits('update:modelValue', base64String);
            path_image.value = base64String
        };
        reader.readAsDataURL(file);
    }
};

const deleteImage = () => {
    path_image.value = null
    emits('update:modelValue', path_image);
    // Clear the file input
    if (fileInputRef.value) {
        fileInputRef.value.value = '';  // Reset the file input value
    }
}


</script>

<style scoped>
.image-display {
    width: 100%;
    max-width: 300px;
    height: auto;
    position: relative;
}

.image-display img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
}

.delete-img {
    position: absolute;
    width: 35px;
    height: 35px;
    border-radius: 50px;
    background: red;
    color: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    right: 0;
    cursor: pointer;

}
</style>